// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".related-performances{--current-color:#fff;--current-color-inverted:#000;background:#000;color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
